<template>
  <page :title="$tc('user._name', 2)" size="is-xlarge">
    <div slot="page-header-right">
      <div style="display: flex; align-items: center;">
        <a class="button mr-2" :href="exportUrl" target="_blank">Export emails</a>
      </div>
    </div>
    <div class="box">
      <user-filter @filter="onFilter"></user-filter>

      <b-tag
        class="mt-2"
        closable
        @close="$router.push('/users?status=active')"
        v-if="$route.query.country"
      >
        <country-flag
          :country-code="$route.query.country"
          with-country-name
        ></country-flag>
      </b-tag>

      <hr />
      <div class="tabs is-marginless">
        <ul>
          <router-link
            v-for="(option, index) in statusOptions"
            :key="index"
            tag="li"
            :to="{
              path: 'users',
              query: option.value ? { status: option.value } : null,
            }"
          >
            <a>{{ option.label }}</a>
          </router-link>
        </ul>
      </div>

      <b-table
        class="is-middle"
        :loading="users.loading"
        :data="users.data"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="users.current_page"
        :per-page="users.per_page"
        :total="users.total"
        @page-change="(page) => users.changePage(page)"
        backend-sorting
        @sort="(field, direction) => users.sort(field, direction)"
        :default-sort="['id', 'desc']"
      >
        <template slot-scope="{ row: user }">
          <b-table-column label="#" width="80" field="id" sortable>
            <router-link :to="'/users/' + user.id">{{ user.id }}</router-link>
          </b-table-column>

          <b-table-column :label="$tc('name')" width="300">{{
            user.name
          }}</b-table-column>

          <b-table-column :label="$tc('email')" width="300">{{
            user.email
          }}</b-table-column>

          <b-table-column :label="$tc('dropdown.country')" width="160">
            <router-link
              v-if="
                user.latest_used_device &&
                  user.latest_used_device.ip_based_country_code
              "
              :to="
                `/users?country=${user.latest_used_device.ip_based_country_code}`
              "
            >
              <country-flag
                :country-code="user.latest_used_device.ip_based_country_code"
                with-country-name
              ></country-flag>
            </router-link>
          </b-table-column>

          <b-table-column :label="$tc('conSocialAcc')" centered>
            <social-account
              v-for="(account, index) in user.social_accounts"
              :key="index"
              :account="account"
              style="margin-right: 5px;"
            ></social-account>
          </b-table-column>

          <b-table-column :label="$tc('verification.verified')" centered>
            <span class="tag is-primary" v-if="user.verified">Verified</span>

            <span class="tag" v-else>{{ $tc('verification.unverified') }}</span>
          </b-table-column>

          <b-table-column
            :label="$tc('download._name')"
            centered
            field="downloads_count"
            width="100"
            sortable
            >{{ user.downloads_count }}</b-table-column
          >

          <b-table-column
            :label="$tc('dater.registered')"
            field="created_at"
            centered
            width="170"
            sortable
          >
            <span class="has-text-grey">{{ user.created_at }}</span>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import SocialAccount from "./components/SocialAccount";
import UserFilter from "../../components/filters/user/Index";
import CountryFlag from "@/components/CountryFlag";
import AddNew from "./components/AddNew";

export default {
  components: {
    UserFilter,
    SocialAccount,
    CountryFlag,
    AddNew,
  },

  data() {
    return {
      statusOptions: [
        { label: this.$tc('user.all'), value: "all" },
        { label: this.$tc('user.active'), value: "active" },
        { label: this.$tc('user.newUser'), value: "new-users" },
        { label: this.$tc('user.currentActiveUser'), value: "active-users" },
        { label: this.$tc('user.inactiveUser'), value: "inactive-users" },
        { label: this.$tc('user.purchasedUser'), value: "purchased-users" },
      ],

      users: new window.PaginatedRemoteCollection(
        "/admin/api/users?include=latestUsedDevice"
      ),
    };
  },

  created() {
    if (!this.$route.query.status) {
      this.ignoreOnce = true;

      this.$router.replace({
        path: "users",
        query: { status: "active" },
      });
    }

    this.load();
  },

  watch: {
    $route() {
      if (this.ignoreOnce) {
        return (this.ignoreOnce = false);
      }

      this.load();
    },
  },

  computed: {
    exportUrl() {
      this.$route.query;

      let url = window.location.href;

      return (
        url.replace(
          "admin/users",
          "admin/api/users"
        ) + "&format=xlsx"
      );
    },
  },

  methods: {
    load() {
      let status =
        this.$route.query.status === "all" ? null : this.$route.query.status;

      let country =
        this.$route.query.country === "all" ? null : this.$route.query.country;

      this.users.filter({ status, country }).changePage(1);
    },

    onFilter(filters) {
      filters = Object.assign(
        {
          search: null,
        },
        filters
      );

      this.users
        .with(filters)
        .changePage(1)
        .load();
    },
  },
};
</script>
